export interface WicketAdminUsersStatistics {
  active_users_count: number;
  register_users_count: number;
  lost_users_count: number;
}
